export default {
  geekcon: -1,
  aicon: 1,
  archsummit: 2,
  bccon: 3,
  cnutcon: 4,
  gmtc: 5,
  gtlc: 6,
  qcon: 7,
  pcon: 8
}
